import * as React from "react";
import { useState, useCallback } from "react";
import { Spinner, Markdown } from "components/common";
import { Input } from "components/bootstrap";
import Modal from "components/bootstrap/Modal";
import ModalSubmit from "components/common/ModalSubmit";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useAITermsAcceptance from "ai/hooks/useAITermsAcceptance";
import useAcceptAITerms from "ai/hooks/useAcceptAITerms";
const DisclaimerModalContent = ({ onClose, onConsent, telemetryEvents }) => {
  const {
    data: { accepted, terms },
    isLoading
  } = useAITermsAcceptance();
  const acceptTerms = useAcceptAITerms(onConsent);
  const [checked, setChecked] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const onCheckboxChange = useCallback((e) => {
    setChecked(e.target.checked);
  }, []);
  const onCancel = useCallback(() => {
    sendTelemetry(telemetryEvents.cancel, {});
    onClose();
  }, [onClose, sendTelemetry, telemetryEvents.cancel]);
  const _onConsent = useCallback(async () => {
    sendTelemetry(telemetryEvents.consent, {});
    await acceptTerms(terms == null ? void 0 : terms.version);
    onConsent();
  }, [sendTelemetry, telemetryEvents.consent, acceptTerms, terms == null ? void 0 : terms.version, onConsent]);
  return accepted === false && !isLoading ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement("h3", null, "Terms and Conditions")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Markdown, { text: terms == null ? void 0 : terms.text }), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "consent-AI-Report-disclamer",
      label: "By using the AI reporting feature, you acknowledge that you have read, understood, and agreed to the terms outlined in this disclaimer.",
      help: /* @__PURE__ */ React.createElement("span", null, "Graylog Germany GmbH reserves the right to modify this disclaimer at any time. Any changes will be communicated to users through appropriate channels."),
      checked,
      onChange: onCheckboxChange
    }
  )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(ModalSubmit, { submitButtonText: "Next", onSubmit: _onConsent, onCancel, disabledSubmit: !checked }))) : /* @__PURE__ */ React.createElement(Spinner, null);
};
export default DisclaimerModalContent;
